<div class="ribbon">
  <span>
<!--    -->
  </span>
  <a mat-icon-button routerLink="/waste/container/{{container.id}}"><mat-icon>more_horiz</mat-icon></a>
</div>
<app-waste-list [container]="true" (event)="onEvent($event)"></app-waste-list>
<div class="count"><span *ngIf="total | async as total">{{count | async}} / {{total}}</span></div>
